import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, CircularProgress } from '@mui/material';
import { t } from 'i18next';
import { fetchNutritionPlanByUUID } from '../../../services/nutrition';
import CreateNutritionPlan from './CreateNutritionPlan';

const DuplicateNutritionPlan = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();

    const [originalPlan, setOriginalPlan] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadPlan = async () => {
            try {
                const data = await fetchNutritionPlanByUUID(uuid);

                setOriginalPlan({
                    uuid: data.uuid,
                    name: data.name,
                    description: data.description,
                    data: data.data
                });
            } catch {
                navigate('/nutricao');
            } finally {
                setLoading(false);
            }
        };

        loadPlan();
    }, [uuid, navigate]);

    if (loading) return <CircularProgress />;
    if (!originalPlan) return <Typography>{t('nutrition.plan_not_found')}</Typography>;

    return (
        <CreateNutritionPlan
            initialTitle={t('planViewer.copy_of', {
                name: originalPlan.name
            })}
            initialDescription={originalPlan.description}
            initialData={originalPlan.data}
        />
    );
};

export default DuplicateNutritionPlan;
